export default __webpack_public_path__ + "3b24a6b94b2631f4d565d76f4f7f18d6.svg";